'use client';
import React, { FC, useEffect, useMemo, useState } from 'react';
import { useTranslation } from '@/hook';
import { ArrowHead } from '../../../../public/Images';
import classes from './styles.module.scss';
import { Question } from '@/types';
import { FAQs } from '@/constants/FAQs';
import Image from 'next/image';
import Typography from '@/components/shared/typography/typography.component';
import colors from '@/theme/colors.module.scss';
import Link from '@/components/WrappedLink';

const CarFinanceFAQs: FC = () => {
    const { t, i18n } = useTranslation();
    const [activeQuestion, setActiveQuestion] = useState<
        number | string | null
    >(null);
    const [data, setData] = useState([] as any);

    useEffect(() => {
        const localizedFAQs = FAQs[i18n.language as keyof typeof FAQs];
        setData(
            localizedFAQs['buy']?.topics?.filter(item =>
                i18n.language === 'en'
                    ? item.topic === 'Car Financing and Insurance'
                    : item.topic === 'التمويل والتأمين'
            )
        );
    }, [i18n.language]);
    const renderQuestions = (questions: Question[]) => {
        return questions.map((question, index) => {
            const selected = question.id === activeQuestion;
            return (
                <div style={{ marginBottom: '16px' }} key={index}>
                    <div
                        className={
                            selected
                                ? classes.accordion_active
                                : classes.accordion
                        }
                        onClick={() =>
                            setActiveQuestion(selected ? null : question.id)
                        }
                    >
                        <Typography variant={'body2'}>{question.q}</Typography>
                        <div className={classes.accordion__arrow}>
                            <Image
                                alt="arrow"
                                style={{
                                    transform: selected
                                        ? 'scale(-1)'
                                        : 'scale(1)',
                                }}
                                src={ArrowHead}
                            />
                        </div>
                    </div>
                    <Typography
                        className={
                            selected
                                ? classes.accordion_active__text
                                : classes.accordion__text
                        }
                        variant={'body2'}
                    >
                        {question.a}
                    </Typography>
                </div>
            );
        });
    };
    const renderTopicQuestions = useMemo(() => {
        return data?.map(
            (item: { topic: string; questions: any[] }, index: number) => {
                return <div key={index}>{renderQuestions(item.questions)}</div>;
            }
        );
    }, [data, renderQuestions]);

    return (
        <div className={classes.container}>
            <div className={classes.containerTitle}>
                <Typography color={colors.primary} className={classes.title}>
                    {t('FAQs')}
                </Typography>
                <Typography color={colors.secondary}>
                    {t('We answer all your questions about financing')}
                </Typography>
            </div>
            <div className={classes.questions}>
                {renderTopicQuestions}
                <Link
                    className={classes.browseButton}
                    href={`/${i18n.language}/how-it-works`}
                >
                    <Typography variant={'body1Medium'}>
                        {t('Browse FAQs')}
                    </Typography>
                </Link>
            </div>
        </div>
    );
};

export default CarFinanceFAQs;
